import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { toCellText } from "../utils/format";

/** ラベルと値の一覧（定義リスト）。SPは1列、PCはラベル列＋値列 */
export const Fields: React.FC<{ items: Array<[string, ReactNode]> }> = ({
  items,
}) => (
  <Box
    component="dl"
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "180px 1fr" },
      gap: 2,
      m: 0,
    }}
  >
    {items.map(([label, value]) => (
      <Box key={label} sx={{ display: "contents" }}>
        <Typography component="dt" color="text.secondary">
          {label}
        </Typography>
        <Typography component="dd" sx={{ m: 0, overflowWrap: "anywhere" }}>
          {toCellText(value)}
        </Typography>
      </Box>
    ))}
  </Box>
);
